import { render, staticRenderFns } from "./EditUserPage.vue?vue&type=template&id=d24cba1e&"
import script from "./EditUserPage.vue?vue&type=script&lang=js&"
export * from "./EditUserPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports